import React from 'react';
import { Title, Text, FindChildTherapistWrap } from './InformationBlock.styles';

const InformationBlock = () => {

  return (

    <>

      <FindChildTherapistWrap>

        <Title>Найдите подходящего психолога <br/> для вашего ребенка</Title>

        <Text>

          Каждый ребенок уникален, и его потребности требуют индивидуального подхода. На этой странице вы найдете проверенных детских психологов, готовых помочь вашему ребенку преодолевать трудности и раскрывать новые возможности. Все консультации проводятся онлайн, что дает вам возможность выбрать специалиста независимо от вашего местоположения. Сделайте первый шаг к эмоциональному благополучию вашего ребенка – выберите психолога, который наилучшим образом подойдет для вас и вашей семьи.

        </Text>

      </FindChildTherapistWrap>

    </>

  );

};

export default InformationBlock;
